import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { gql, useLazyQuery } from '@apollo/client';
import { Button, Loader, notification } from '../../../../../ui-library';

const GET_SECURITIES = gql`
    query SearchSecurities($language: String, $ids: [Int!]) {
        securities(language: $language, where: { id: { in: $ids } }) {
            items {
                id
                name
                factsheet
            }
        }
    }
`;

const FactsheetRenderer = ({ securityId }) => {
    const { t, i18n: { language } } = useTranslation();

    const [getSecurities, { loading }] = useLazyQuery(GET_SECURITIES);

    const downloadFile = useCallback(async () => {
        try {
            const securityResult = await getSecurities({
                variables: {
                    language,
                    ids: [securityId],
                },
            });

            const factSheetURL = securityResult?.data?.securities?.items?.[0]?.factsheet;

            if (factSheetURL === '[Not localized]') {
                global.open('');
            } else {
                global.open(securityResult?.data?.securities?.items?.[0]?.factsheet?.replace('url:', ''));
            }
        } catch (err: any) {
            notification.open({
                content: err?.message || `${t('contactGroups.somethingWentWrong')}`,
                type: 'error',
            });
        }
    }, [securityId, language]);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <Button disabled={loading} onClick={downloadFile}>{loading ? <Loader/> : t('portfolio.createNewPortfolio.strategy.factsheetUrl')}</Button>;
};

export default FactsheetRenderer;
